'use strict';

var App = require('app');
var i18n = require('utils/i18n');
var PasswordResetView = require('components/activation/views/password_reset_view');
var utils = require('components/common/utils');

var ActivationController = {};

var Types = {
    AccountActivation: '1',
    PasswordReset: '2',
    ChangeMail: '3',
    DeviceAccessInvite: '4',
    DeviceAccessTransfer: '5',
    GrantCompanyPermissions: '6',
    InviteGroup: '7',
};

var activate = function (params) {
    utils.showLoadingHint(params.hint);
    doActivation(
        {
            type: params.type,
            token: params.token,
        },
        function (xhr) {
            var hint = xhr.responseText;
            if (xhr.responseJSON != undefined) {
                hint = xhr.responseJSON.error;
            }
            switch (params.type) {
                case Types.PasswordReset:
                case Types.DeviceAccessInvite:
                case Types.GrantCompanyPermissions:
                case Types.DeviceAccessTransfer:
                case Types.InviteGroup:
                    if (hint == 'user_not_registered') {
                        App.trigger('signup:show', params);
                        return;
                    }
                    if (hint == 'username_and_email_do_not_match') {
                        hint = i18n.TR('Falsche E-Mail-Adresse für diese Rechtefreigabe.');
                    }
                    if (hint == 'login_required') {
                        params.activation = { type: params.type, token: params.token };
                        params.info = i18n.TR(
                            'Aktivierung nur für angemeldete Nutzer möglich. Bitte loggen Sie sich ein.'
                        );
                        App.trigger('login:show', params);
                        return;
                    }
                    break;
            }
            utils.showHint({
                title: params.errorTitle,
                hint: hint,
                hintClass: 'info',
                activation: params,
            });
        },
        function () {
            utils.showHint({
                title: params.successTitle,
                hint: params.successHint,
                hintClass: params.successHint === undefined ? undefined : 'success',
            });
        }
    );
};

ActivationController.processActivation = function (type, token, errors) {
    switch (type) {
        case Types.AccountActivation: {
            activate({
                hint: i18n.TR('Aktivierung wird durchgeführt'),
                type: type,
                token: token,
                errorTitle: i18n.TR('Accountaktivierung fehlgeschlagen'),
                successTitle: i18n.TR('Account aktiviert'),
                successHint: i18n.TR('Sie können sich jetzt einloggen.'),
            });
            break;
        }
        case Types.PasswordReset: {
            var view = new PasswordResetView({
                controller: this,
                token: token,
                errors: errors,
            });
            App.main.show(view);
            break;
        }
        case Types.ChangeMail: {
            activate({
                hint: i18n.TR('Aktivierung wird durchgeführt'),
                type: Types.AccountActivation,
                token: token,
                errorTitle: i18n.TR('Ändern der E-Mail Adresse fehlgeschlagen'),
                successTitle: i18n.TR('E-Mail Adresse erfolgreich geändert.'),
            });
            break;
        }
        case Types.DeviceAccessInvite: {
            activate({
                hint: i18n.TR('Freigabe wird bearbeitet'),
                type: type,
                token: token,
                errorTitle: i18n.TR('Gerätefreigabe fehlgeschlagen'),
                successTitle: i18n.TR('Gerätefreigabe erfolgreich.'),
            });
            break;
        }
        case Types.DeviceAccessTransfer: {
            activate({
                hint: i18n.TR('Übertragung wird bearbeitet'),
                type: type,
                token: token,
                errorTitle: i18n.TR('Geräteübertragung fehlgeschlagen'),
                successTitle: i18n.TR('Geräteübertragung erfolgreich.'),
            });
            break;
        }
        case Types.GrantCompanyPermissions: {
            activate({
                hint: i18n.TR('Administrative Rechte werden vergeben'),
                type: type,
                token: token,
                errorTitle: i18n.TR('Rechtevergabe fehlgeschlagen'),
                successTitle: i18n.TR('Rechtevergabe erfolgreich.'),
            });
            break;
        }
        case Types.InviteGroup: {
            activate({
                hint: i18n.TR('Freigabe wird bearbeitet'),
                type: type,
                token: token,
                errorTitle: i18n.TR('Freigabe fehlgeschlagen'),
                successTitle: i18n.TR('Freigabe erfolgreich'),
            });
            break;
        }
        default: {
            utils.showHint({
                title: i18n.TR('Ungültiger Aktivierungslink'),
                hint: i18n.TR('Der Aktivierungslink ist ungültig.'),
                hintClass: 'danger',
            });
        }
    }
};

ActivationController.doPasswordReset = function (config) {
    var self = this;

    utils.showLoadingHint(i18n.TR('Aktivierung wird durchgeführt'));
    doActivation(
        {
            type: Types.PasswordReset,
            token: config.token,
            value0: config.formData.password,
        },
        function (xhr) {
            var errors = xhr.responseJSON || { error: xhr.responseText };
            self.processActivation(Types.PasswordReset, config.token, errors);
        },
        function () {
            utils.showHint({
                title: i18n.TR('Neues Passwort gesetzt'),
                hint: i18n.TR('Sie können sich jetzt einloggen.'),
                hintClass: 'success',
                hintID: 'new-password',
            });
        }
    );
};

var doActivation = function (data, errorCB, successCB) {
    App.ajax({
        url: '/api/v1/account/activate',
        type: 'POST',
        data: data,
        error: errorCB,
        success: successCB,
    });
};

module.exports = ActivationController;
